/* unplugin-vue-components disabled */import script from "./addAccountModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./addAccountModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__